"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _indexSetterDate = _interopRequireDefault(require("./indexSetterDate"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'UpdatePickCtnDialog',
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default,
    indexSetterDate: _indexSetterDate.default
  },
  props: {
    blNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      listQuery: {
        currentPage: 1,
        pageSize: 100,
        namedParameters: {}
      },
      total: 0,
      tableData: [],
      poolTypeList: [],
      form: {
        setterDate: ''
      },
      loading: null,
      hotSettings: {
        dragCheck: true,
        height: 'calc(50vh - 215px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleSearch: function handleSearch() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.searchContainer)(this.listQuery).then(function (res) {
        if (res.success) {
          _this.total = res.data.totalRecord;
          _this.listQuery.currentPage = res.data.currentPage;
          _this.listQuery.pageSize = res.data.pageSize;
          // 映射数据，添加 setterDate 并存储原始日期
          _this.tableData = res.data.records.map(function (record) {
            var newRecord = (0, _objectSpread2.default)({}, record);
            newRecord._originalSetterDate = record.setterDate || null; // 存储原始日期
            return newRecord;
          });
        }
      }).catch(function (err) {}).finally(function () {
        if (_this.loading) _this.loading.close();
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleNext: function handleNext() {
      var _this2 = this;
      // 日期校验逻辑：检查每行的setterDate是否早于原始日期
      var invalidRows = [];
      for (var i = 0; i < this.tableData.length; i++) {
        var row = this.tableData[i];

        // 如果有日期值才进行校验
        if (row.setterDate && row._originalSetterDate) {
          // 使用日期对象进行比较
          var newDate = new Date(row.setterDate);
          var originalDate = new Date(row._originalSetterDate);

          // 去除时间部分
          newDate.setHours(0, 0, 0, 0);
          originalDate.setHours(0, 0, 0, 0);

          // 如果新日期早于原始日期，记录该行
          if (newDate < originalDate) {
            invalidRows.push({
              containerNo: row.containerNo || "\u884C".concat(i + 1),
              setterDate: row.setterDate,
              originalDate: row._originalSetterDate
            });
          }
        }
      }

      // 如果有不符合要求的行，提示错误并中断保存
      if (invalidRows.length > 0) {
        var errorMessage = '以下集装箱的提箱日期不能早于原始日期：\n\n';
        invalidRows.forEach(function (row) {
          errorMessage += "".concat(row.containerNo, ": \u5F53\u524D\u8BBE\u7F6E ").concat(row.setterDate, ", \u4E0D\u80FD\u65E9\u4E8E ").concat(row.originalDate, "\n");
        });
        this.$alert(errorMessage, '日期错误', {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true
        });
        return; // 中断保存过程
      }

      // 通过校验后，继续原有的保存逻辑
      var requestData = (0, _utils.deepClone)(this.tableData);
      requestData.forEach(function (item) {
        if (item.hasOwnProperty('setterDate') && item.setterDate) {
          item.pickUpDate = "".concat(item.setterDate, " 00:00:00");
          delete item.setterDate;
        } else {
          item.pickUpDate = null;
          if (item.hasOwnProperty('setterDate')) {
            delete item.setterDate;
          }
        }
      });
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.doSavePickUpCtnRecord)(requestData).then(function (res) {
        _this2.loading.close();
        _this2.$emit('handleNextConfirmPrint', _this2.tableData);
      }).catch(function (err) {
        _this2.$message.error(err.message || '保存失败');
        if (_this2.loading) {
          _this2.loading.close();
        }
      }).finally(function () {
        if (_this2.loading) {
          _this2.loading.close();
        }
      });
    },
    opened: function opened() {
      this.listQuery.namedParameters.blNo = this.blNo;
      this.handleSearch();
    },
    handleDatePickerBlur: function handleDatePickerBlur() {
      var _this3 = this;
      var newDateString = this.form.setterDate;
      if (!newDateString) {
        // 如果新日期为空，可以选择不处理或给出提示
        // this.$message.warning('请选择一个日期');
        return;
      }
      var earliestOriginalDate = null;
      var hasOriginalDates = false;

      // 查找最早的原始日期
      this.tableData.forEach(function (item) {
        if (item._originalSetterDate) {
          hasOriginalDates = true;
          if (earliestOriginalDate === null || item._originalSetterDate < earliestOriginalDate) {
            earliestOriginalDate = item._originalSetterDate;
          }
        }
      });

      // 如果存在原始日期，并且新日期早于最早的原始日期，则阻止修改
      if (hasOriginalDates && earliestOriginalDate && newDateString < earliestOriginalDate) {
        this.$message.warning("\u63D0\u8D27\u65E5\u671F\u4E0D\u80FD\u65E9\u4E8E\u6700\u65E9\u7684\u539F\u59CB\u65E5\u671F (".concat(earliestOriginalDate, ")"));
        // 将日期选择器的值重置为最早的原始日期
        this.$nextTick(function () {
          _this3.form.setterDate = earliestOriginalDate;
        });
        return; // 不更新表格
      }

      // 如果新日期有效（不早于最早原始日期），则更新表格所有行的日期
      this.tableData.forEach(function (item) {
        // 只有当新日期不为空时才更新
        if (newDateString) {
          _this3.$set(item, 'setterDate', newDateString);
        }
        // 如果新日期为空，可以选择清空或保留原值，当前逻辑是保留原值（因为前面有 !newDateString 的 return）
      });

      // 触发 hotTable 重新渲染以显示更新
      if (this.$refs.hotTable && this.$refs.hotTable.hotInstance) {
        this.$refs.hotTable.hotInstance.render();
      }
      // this.$refs.hotTable.resizeTo() // resizeTo 可能不是必须的，render 通常足够
    },
    closed: function closed() {},
    handleConfirmPrint: function handleConfirmPrint() {
      this.$emit('handleConfirmPrint');
    },
    // 验证费用行的函数
    validateFeeRow: function validateFeeRow(row, index, feeType) {
      // 定义费用类型常量 
      var FEE_TYPE = {
        DEMURRAGE: 'demurrageFee',
        LOCAL: 'localFee'
      };

      // 基础必填字段
      var requiredFields = ['paymentDate', 'paymentMethod', 'paymentCurrency', 'paymentAmount', 'invoiceNumber'];
      var requiredFieldNames = ['付款日期', '付费方式', '币种', '付款金额', '发票号码'];

      // 根据费用类型设置类型名称和额外必填字段
      var feeTypeName = '';
      if (feeType === FEE_TYPE.DEMURRAGE) {
        feeTypeName = this.$t('blExchangeAppointment.demurrageFees');
        requiredFields.push('attachmentId');
        requiredFieldNames.push('滞期费水单');
      } else if (feeType === FEE_TYPE.LOCAL) {
        feeTypeName = this.$t('blExchangeAppointment.localFees');
        requiredFields.push('attachmentId');
        requiredFieldNames.push('银行水单');
      }

      // 检查必填字段
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        var fieldName = requiredFieldNames[i];
        if (!row[field]) {
          this.$message.warning("".concat(feeTypeName, "\u7B2C").concat(index + 1, "\u884C\u7684").concat(fieldName, "\u4FE1\u606F\u4E0D\u5B8C\u6574\uFF0C\u8BF7\u586B\u5199\u5B8C\u6574"));
          return false;
        }
      }

      // 特殊条件：当支付方式为网银转账(1)时，银行和付款账号必填
      if (row.paymentMethod === 1 || row.paymentMethod === '1') {
        if (!row.paymentBank) {
          this.$message.warning("".concat(feeTypeName, "\u7B2C").concat(index + 1, "\u884C\u7684\u652F\u4ED8\u94F6\u884C\u4FE1\u606F\u4E0D\u5B8C\u6574\uFF0C\u652F\u4ED8\u65B9\u5F0F\u4E3A\u7F51\u94F6\u8F6C\u8D26\u65F6\u5FC5\u987B\u9009\u62E9\u94F6\u884C"));
          return false;
        }
        if (!row.paymentAccount) {
          this.$message.warning("".concat(feeTypeName, "\u7B2C").concat(index + 1, "\u884C\u7684\u4ED8\u6B3E\u8D26\u53F7\u4FE1\u606F\u4E0D\u5B8C\u6574\uFF0C\u652F\u4ED8\u65B9\u5F0F\u4E3A\u7F51\u94F6\u8F6C\u8D26\u65F6\u5FC5\u987B\u586B\u5199\u4ED8\u6B3E\u8D26\u53F7"));
          return false;
        }
      }

      // 验证金额格式
      if (!/^\d+(\.\d{1,2})?$/.test(row.paymentAmount)) {
        this.$message.warning("".concat(feeTypeName, "\u7B2C").concat(index + 1, "\u884C\u7684\u4ED8\u6B3E\u91D1\u989D\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u8F93\u5165\u6709\u6548\u7684\u91D1\u989D\u683C\u5F0F\uFF08\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF09"));
        return false;
      }
      return true;
    },
    // 根据hasDemurrage决定是否验证滞期费数据
    validateDemurrageFees: function validateDemurrageFees() {
      if (this.hasDemurrage) {
        // 验证滞期费数据
        for (var i = 0; i < this.demurrageFees.length; i++) {
          if (!this.validateFeeRow(this.demurrageFees[i], i, 'demurrageFee')) {
            return false;
          }
        }
      } else {
        // 如果没有滞期费，不进行校验，且确保demurrageFees为空数组
        this.demurrageFees = [];
      }
      return true;
    },
    // 验证本地费用数据
    validateLocalFees: function validateLocalFees() {
      if (this.hasLocalFee) {
        for (var i = 0; i < this.localFees.length; i++) {
          if (!this.validateFeeRow(this.localFees[i], i, 'localFee')) {
            return false;
          }
        }
      }
      return true;
    },
    handleSave: function handleSave() {
      if (!this.validateDemurrageFees() || !this.validateLocalFees()) {
        return;
      }
      this.handleNext();
    }
  }
};